import { IGeo, PrimaryMetroRegions } from '@cian/chats-api/lib/browser-entry';

export function isPrimaryMetroRegion(geo: IGeo): boolean {
  if (geo && geo.undergrounds && geo.undergrounds.length && geo.address && geo.address.length) {
    return PrimaryMetroRegions.includes(geo.address[0].id);
  }

  return false;
}
